<template>
  <div>
    <v-navigation-drawer
      :value="isAddNewEquipeSidebarActive"
      temporary
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
      app
      @input="val => $emit('update:is-add-new-equipe-sidebar-active', val)"
    >
      <v-card height="100%">
        <div class="drawer-header d-flex align-center mb-4">
          <span class="font-weight-semibold text-base text--primary">Criar Equipe</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-add-new-equipe-sidebar-active', false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="onSubmit"
          >
            <v-text-field
              v-model="equipeData.nome"
              outlined
              dense
              :rules="[validators.required]"
              label="Nome"
              placeholder="Nome"
              hide-details="auto"
              class="mb-6"
            ></v-text-field>

            <v-textarea
              v-model="equipeData.descricao"
              outlined
              dense
              auto-grow
              label="Descrição"
              placeholder="Descrição"
              hint="Máximo de 150 caracteres"
              hide-details="auto"
              class="mb-6"
            ></v-textarea>

            <v-autocomplete
              v-model="equipeData.idGestorPrincipal"
              :rules="[v => !!v || 'Este campo é obrigatório']"
              :items="colaboradores"
              :loading="isAutompleteLoading"
              :search-input.sync="search"
              hide-no-data
              hide-selected
              item-text="nome"
              item-value="id"
              outlined
              dense
              clearable
              label="Gestor principal"
              placeholder="Digite algo para pesquisar"
              class="mb-6"
            >
            </v-autocomplete>

            <v-btn
              color="primary"
              class="me-3 mb-1"
              type="submit"
            >
              <v-progress-circular
                v-if="loadings"
                class="mx-6"
                indeterminate
                color="secundary"
              ></v-progress-circular>
              <span v-else> Criar </span>
            </v-btn>
            <v-btn
              color="secondary"
              class="mb-1"
              outlined
              type="reset"
              @click="resetEquipeData"
            >
              Cancelar
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import {
  nameValidator,
  emailValidator,
  passwordValidator,
  required,
  select,
} from '@core/utils/validation'
import { isTelefoneCelularValido, isCpfValido } from '@/utils/validation'
import EquipeService from '@/services/modules/EquipeService'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  model: {
    prop: 'isAddNewEquipeSidebarActive',
    event: 'update:is-add-new-equipe-sidebar-active',
  },
  props: {
    isAddNewEquipeSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    loading: true,
    colaboradores: [],
    isAutompleteLoading: undefined,
  }),

  watch: {
  // dispara quando o sidebar abre
    isAddNewEquipeSidebarActive(val) {
      if (val) {
        this.carregarGestores()
      }
    },

    async search(val) {
      if (this.isAutompleteLoading) return
      await this.carregarGestores(val)
    },
  },

  methods: {
    async carregarGestores(nome = null) {
      try {
        this.isAutompleteLoading = true
        this.colaboradores = await ColaboradorService.get(nome, true, null, 1)
      } finally {
        this.isAutompleteLoading = false
      }
    },
  },
  setup(props, { emit }) {
    const blankEquipeData = {
      nome: '',
      descricao: '',
      idGestorPrincipal: 0,
    }

    const equipeData = ref(JSON.parse(JSON.stringify(blankEquipeData)))
    const search = ref(null)

    // O componente v-autocomplete possui um bug: se você deletar a seleção, o componente não dá erro, apesar das rules, por isso a validação com o watch
    watch(search, newValue => {
      if (!newValue) {
        equipeData.value.idGestorPrincipal = 0
      }
    })

    const valid = ref(false)
    const form = ref(null)

    const loadings = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const errorMsg = ref('Entre em contato com o servidor.')
    const resetEquipeData = () => {
      equipeData.value = JSON.parse(JSON.stringify(blankEquipeData))
      resetForm()
      setTimeout(() => {
        emit('update:is-add-new-equipe-sidebar-active', false)
      }, 2000)
    }

    const onSubmit = () => {
      loadings.value = !loadings.value

      if (valid.value) {
        EquipeService.criar(equipeData.value)
          .then(() => {
            loadings.value = !loadings.value
            emit('refetch-data')
            resetEquipeData()
          })
          .catch(() => {
            loadings.value = !loadings.value
          })
      } else {
        loadings.value = !loadings.value
        validate()
      }
    }

    return {
      search,
      resetEquipeData,
      onSubmit,
      validate,
      form,
      equipeData,
      valid,
      blankEquipeData,
      loadings,
      errorMsg,
      validators: {
        required,
        emailValidator,
        select,
        nameValidator,
        isCpfValido,
        passwordValidator,
        isTelefoneCelularValido,
      },

      icons: {
        mdiClose,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
